import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import {ReactComponent as CrossIcon} from "assets/img/svg/CrossIcon.svg"
import "./style.scss";
import ListComponent from './ListComponent';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ALoader from 'views/pages/manage/common/a-loader';
import Error from '../errorHandlimg/Error';
const rowData=[
    {id:0,type:'QR','description':'dddd',voucherId:'123',transactionDateAndTime:'2:00PM',term:'2426',courseId:'33333',voucherBalanceAmount:230,status:'SUCCESS'},
    {id:1,type:'QR','description':'dddd',voucherId:'123',transactionDateAndTime:'2:00PM',term:'2426',courseId:'33333',voucherBalanceAmount:222,status:'SUCCESS'},
    {id:2,type:'QR','description':'dddd',voucherId:'123',transactionDateAndTime:'2:00PM',term:'2426',courseId:'33333',voucherBalanceAmount:212,status:'FAILED'}
]
const Vouchers=({isOpen,setOpen,vouchersList,voucherLoader,setVoucherLoader,setVoucherList,accessiblePaymentModeList, module, getVouchers})=>{
  const [errorMgs,setErrorMgs]= useState()

    return vouchersList?.length>0&&<Dialog
        open={isOpen}
        PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
      >
        <div className="select-concession-voucher-popup">
          <div className="d-flex " style={{ justifyContent: "space-between" }}>
            {voucherLoader&&<ALoader/>}
            <div className="heading-4 color-dark">Vouchers available for receipt processing </div>
            <CrossIcon onClick={()=>setOpen(false)}/>
            </div>
            {isOpen&&vouchersList.length>0&&<ListComponent getVouchers={getVouchers} rows={vouchersList} setRows={setVoucherList} setOpen={setOpen} setVoucherLoader={setVoucherLoader} setErrorMgs={setErrorMgs} isOpen={isOpen} accessiblePaymentModeList={accessiblePaymentModeList} module={module}/>}
            <Error errorMgs={errorMgs} />
    </div>
    </Dialog>
    
}
export default Vouchers